<footer class="app-footer">
  <span></span>
  <span class="spacer"></span>
  <span>Powered by Cloud Smart School</span>
</footer>
